// extracted by mini-css-extract-plugin
export default {"container":"_02_Ntrip_container__vdCx8","rows":"_02_Ntrip_rows__Q-D8J","row":"_02_Ntrip_row__hIgMP","label":"_02_Ntrip_label__DORtZ"};